import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { baseUrl } from '../config';
import axios from 'axios';
import buildInfo from '../config/buildInfo.json';
import { secsToStr, getTimestamp } from '../tools/time';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 650,
    height: 370,
    maxWidth: 'calc(100% - 20px)',
    maxHeight: 'calc(100% - 20px)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#f4f4f4',
    padding: '1em 2.5em',
    position: 'relative',
  },
  title: {
    width: '100%',
    fontSize: '1.25em',
    textAlign: 'center',
    paddingRight: '1em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 8,
  },
  body: {
    padding: '1em 2.5em',
    overflowY: 'auto',
  },
  heading: {
    fontWeight: 500,
  },
  action: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  selectWrap: {
    width: 300,
    display: 'block',
    marginBottom: 20,
    '& > div': {
      width: '100%',
    },
  },
  textArea: {
    width: '100%',
    marginBottom: 5,
    '& textarea': {
      fontSize: 14,
    },
  },
  fileInput: {
    display: 'none',
  },
  attachment: {
    color: '#999',
    fontSize: 13,
    marginBottom: 5,
  },
  okMessage: {
    textAlign: 'center',
    '& p': {
      margin: '50px 0',
      fontSize: 18,
      color: 'green',
    },
  },
  errorMessage: {
    textAlign: 'center',
    '& p': {
      margin: '50px 0',
      fontSize: 18,
      color: '#b70d0d',
    },
    '& button': {
      margin: '0 10px',
    },
  },
  space: {
    width: '100%',
    height: 40,
    color: '#999',
  },
  '@media(max-width: 500px)': {
    header: {
      padding: '1em 1.5em 5px',
    },
    paper: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    body: {
      padding: '1em 1.5em',
    },
  }
}));


function ReportError (props) {
  const classes = useStyles();
  const href = props.href;
  const [ location, setLocation ] = useState(href ? 2 : '');
  const [ file, setFile ] = useState(null);
  const [ comment, setComment ] = useState('');
  const [ status, setStatus ] = useState({ sent: false });

  const handleClose = () => {
    props.close(false);
  }

  const handleLocChange = ev => {
    setLocation(ev.target.value);
  }

  const fileChangeHandler = ev => {
    setFile(ev.target.files[0]);
  }

  const sendReport = () => {
    setStatus({sent: false, waiting: true });
    const system = props.auth.browser.system;
    const browser = `${system.browser.name} ${system.browser.version}`;
    const os = `${system.os.name} ${system.os.version}`;
    const platform = system.platform.type;
    const build = buildInfo.build;
    const status = props.auth.browser.status;
    const formData = new FormData();
    let locInfo;
    const secs = getTimestamp() - props.auth.id;
    const time = secsToStr(secs, 'hh:mm:ss');
    const user = props.user ? props.user : 'unknown';
    switch(location) {
      case 1:
        locInfo = 'interfejs użytkownika';
        break;
      case 2:
        locInfo = 'Ćwiczenie / gra';
        break;
      default:
        locInfo = 'inne';
    }
    formData.set('location', locInfo);
    formData.set('comment', comment);
    formData.set('browser', browser);
    formData.set('platform', platform);
    formData.set('build', build);
    formData.set('status', status);
    formData.set('os', os);
    formData.set('user', user);
    formData.set('time', time);
    if (href) {
      formData.set('href', href);
    } else {
      formData.set('href', 'none');
    }
    formData.set('sum',357);
    if (file) formData.append('screen', file);
    const request = axios.post(`${baseUrl}/report-error.php`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    request
      .then(response => {
          setStatus({ ...response.data, sent: true });
        }
      )
      .catch(e => {
        setStatus({sent: true, code: 404, message: 'Przepraszamy, wystąpił błąd podczas wysyłania formularza. Proszę skorzystać z formularza kontaktowego na stronie www.'});
      })
  }

  const renderMessage = () => {
    return (
      <div className={classes.okMessage}>
        <p>{status.message}</p>
        <div>
          <Button variant="contained" color="primary" onClick={handleClose}>Zamknij</Button>
        </div>
      </div>
    );
  }

  const renderError = () => {
    return (
      <div className={classes.errorMessage}>
        <p>{status.message}</p>
        <div>
          <Button variant="contained" color="secondary" onClick={() =>  setStatus({ sent: false })}>Ponów próbę</Button>
          <Button variant="outlined" color="primary" onClick={handleClose}>Zamknij</Button>
        </div>
      </div>
    );
  }

  const renderForm = () => {
    return (
      <div>
        {!href && <FormControl className={classes.selectWrap}>
          <InputLabel id="demo-simple-select-label">Miejsce występowa błędu</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={location}
            onChange={handleLocChange}
          >
            <MenuItem value={1}>interfejs użytkownika</MenuItem>
            <MenuItem value={2}>ćwiczenie lub gra</MenuItem>
            <MenuItem value={3}>inne</MenuItem>
          </Select>
        </FormControl>}
        {(location !== 2 || href) &&<div>
          {href && <div className={classes.space}>Zgłoszenie błędu do ćwiczenia</div>}
          <TextField
            label="Opis błędu"
            multiline
            rows="6"
            value={comment}
            onChange={ev => setComment(ev.target.value)}
            variant="outlined"
            className={classes.textArea}
            disabled={location ===''}
          />
          <div className={classes.attachment}>{file && <span>{file.name}</span>}{!file && ' '}</div>
          <div className={classes.action}>
            <input
              accept="image/*"
              className={classes.fileInput}
              id="contained-button-file"
              type="file"
              onChange={fileChangeHandler}
            />
            <label htmlFor="contained-button-file">
              <Button variant="outlined" component="span" disabled={location ===''}>
                Dołącz zrzut ekranu
              </Button>
            </label>
            <Button 
              variant="contained" 
              color="primary" 
              disabled={location ==='' || comment.length < 10}
              onClick={sendReport}
            >Wyślij</Button>
          </div>
        </div>}
        {location ===2 && !href && <div>
          <p>Proszę uruchomić ćwiczenie i z menu górnego wybrać "Zgłoś błąd". Do raportu dostarczone wówczas będą automatycznie informacje na temat ćwiczenia, którego dotyczy zgłoszenie.</p>
        </div>}
      </div>
    );
  }

  const renderWaiting = () => {
    return (<p>Wysyłam formularz...</p>);
  }

  return (
    <Modal open={true} onClose={handleClose} className={classes.wrapper}>
      <div className={classes.paper}>
        <div className={classes.header}>
          <div className={classes.title}>Raportowanie błędów</div>
          <IconButton className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classes.body}>
          {status.sent && status.code === 200 && renderMessage()}
          {status.sent  && status.code !== 200 && renderError()}
          {!status.sent && !status.waiting && renderForm()}
          {!status.sent && status.waiting && renderWaiting()}
        </div>
      </div>
    </Modal>
  );
}

const mapStateToProps = state => {
  return { 
    auth: state.auth,
    user: state.userState.user,
  }
}

export default connect(mapStateToProps)(ReportError);
